export * from './terms-of-service-page.component';
